<template>
    <el-card class="box-card" shadow="always">
        <div class="title_btn">
            <div>*案例banner图</div>
            <el-button type="primary" @click="addNum">添加</el-button>
        </div>
        <div class="banner_list">
            <div class="list">
                <div class="form-item">
                    <div class="title">*排列序号</div>
                    <div class="title">自定义ALT</div>
                    <div class="title img_title">*pc端banner图<div class="el-upload__tip">(建议尺寸为1920*508)</div></div>
                    <div class="title img_title">*H5端banner图<div class="el-upload__tip">(建议尺寸为375*550)</div></div>
                </div>

                <div v-for="(index) in num" :key="index" class="form-item co_m">
                    <el-input-number v-model="banner_item[index-1].sort" :min="1" clearable class="name-input" placeholder="请输入排列序号" /></el-input-number>
                    <el-input v-model="banner_item[index-1].image_alt" clearable class="name-input" placeholder="请输入自定义ALT" />
                    <imageUpload v-model="banner_item[index-1].pc_banner" :limit="1" />
                    <imageUpload v-model="banner_item[index-1].h5_banner" :limit="1" />
                    <div v-show="index!=1" class="el-icon-remove" @click="delectNum(index-1)"></div>
                </div>
            </div>
        </div>

        <div class="case_wrap">
            <div class="case-item">
                <span class="label">*案例副标题</span>
                <el-input v-model="bannerInfo.case_sub_title" type="textarea" :autosize="{ minRows: 3, minCols:20}" placeholder="请填写案例副标题"></el-input>
            </div>

            <div class="case-item">
                <span class="label">*使用功能介绍</span>
                <el-input v-model="bannerInfo.function_introduction" type="textarea" :autosize="{ minRows: 3, minCols:20}" placeholder="请填写案例副标题"></el-input>
            </div>

            <div class="case-item">
                <span class="label">*使用目的介绍</span>
                <el-input v-model="bannerInfo.purpose_introduction" type="textarea" :autosize="{ minRows: 3, minCols:20}" placeholder="请填写案例副标题"></el-input>
            </div>

            <div class="case-item">
                <span class="label">*业务痛点</span>
                <el-input v-model="bannerInfo.business_pain_points" type="textarea" :autosize="{ minRows: 3, minCols:20}" placeholder="请填写案例副标题"></el-input>
            </div>

            <div class="case-item">
                <span class="label">*解决方案</span>
                <el-input v-model="bannerInfo.solution" type="textarea" :autosize="{ minRows: 3, minCols:20}" placeholder="请填写案例副标题"></el-input>
            </div>

            <div class="case-item">
                <span class="label">*实施效果</span>
                <el-input v-model="bannerInfo.implementation_effect" type="textarea" :autosize="{ minRows: 3, minCols:20}" placeholder="请填写案例副标题"></el-input>
            </div>
        </div>
    </el-card>
</template>
<script>
import baseURL from '@/configs/baseUrl';
import utils from '@/jslibs/utils';
import { imgDomain } from '@/configs/env';
import imageUpload from '@/components/ImageUpload';
export default {
    components: {
        imageUpload
    },
    props: {
        caseInfo: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            imgDomain,
            num: 1,
            headers: {
                'X-Access-Token': utils.getCookie('X-Access-Token') || ''
            },
            baseURL,
            loading: false,
            banner_item: [
                { sort: "", image: "", image_alt: "", h5_image: "", h5_banner: [], pc_banner: [] }
            ],
            bannerInfo: {
                case_sub_title: "",
                function_introduction: "",
                purpose_introduction: "",
                business_pain_points: "",
                solution: "",
                implementation_effect: ""
            }
        }
    },

    mounted() {

    },

    methods: {
        addNum() {
            this.num++;
            this.banner_item.push({ sort: "", image: "", image_alt: "", h5_image: "", h5_banner: [], pc_banner: [] })
        },

        delectNum(index) {
            this.num--;
            this.banner_item.splice(index, 1);
        },

        verifyInput() {
            const { case_sub_title, function_introduction, purpose_introduction, business_pain_points, solution, implementation_effect } = this.bannerInfo;
            if (!this.banner_item[0].sort) {
                this.$notify.error({ title: '请输入案例banner排列序号' });
                return false
            }
            if (!this.banner_item[0].pc_banner.length) {
                this.$notify.error({ title: '请上传PC端banner图' });
                return false
            }
            if (!this.banner_item[0].h5_banner.length) {
                this.$notify.error({ title: '请上传H5端banner图' });
                return false
            }
            this.banner_item.forEach((item, index) => {
                item.image = item.pc_banner.join();
                item.h5_image = item.h5_banner.join();
            })
            const banner_item = this.banner_item.filter((item, index) => {
                return (item.sort && item.h5_image && item.image)
            })
            if (!case_sub_title) {
                this.$notify.error({ title: '请输入案例副标题' });
                return false
            }
            if (!function_introduction) {
                this.$notify.error({ title: '请输入使用功能介绍' });
                return false
            }
            if (!purpose_introduction) {
                this.$notify.error({ title: '请输入使用目的介绍' });
                return false
            }
            if (!business_pain_points) {
                this.$notify.error({ title: '请输入业务痛点' });
                return false
            }
            if (!solution) {
                this.$notify.error({ title: '请输入解决方案' });
                return false
            }
            if (!implementation_effect) {
                this.$notify.error({ title: '请输入实施效果' });
                return false
            }
            this.bannerInfo.banner_item = banner_item;
            return true;
        }
    }
};
</script>
<style lang="less" scoped>
    .box-card{
        margin: 60px 0;
        .title_btn{
            div{
                margin-bottom: 20px;
            }
            button{
                margin-bottom: 20px;
            }
        }
        .banner_list{
            border: 1px solid #ccc;
            padding: 20px;
            .list{
                .form-item {
                    display: flex;
                    flex-wrap: wrap;
                    margin-left: 0;
                    margin-bottom: 10px;
                    .title{
                        width: 260px;
                        text-align: center;
                        margin-right: 30px;
                    }
                    .img_title{
                        width: 130px;
                    }
                    /deep/ .dankal-image-upload{
                        width: 130px;
                        justify-content: center;
                        .add-box{
                            margin: 0 auto;
                            padding-left: 0;
                            margin-top: 0;
                            img{
                                width: 60px;
                                height: 60px;
                            }
                        }
                        p{
                          width:60px;
                          height: 60px;
                          margin: 0;
                        }
                    }
                    .name-input{
                        width: 260px;
                        height: 40px;
                        margin-right: 30px;
                    }
                    .el-icon-remove{
                        font-size: 40px;
                        display: flex;
                        align-items: center;
                    }
                    .img_list{
                        width: 130px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 30px;
                        /deep/.el-upload{
                            width: 60px;
                            height: 60px;
                            line-height:70px;
                            img{
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                }

                .co_m{
                    margin-bottom: 20px;
                }
            }
        }
        .case_wrap{
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            margin-top: 30px;
            .case-item{
                width: 48%;
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                .el-textarea{
                    width: 88%;
                }
                .label{
                    width: 100px;
                }
            }
        }
        .el-upload__tip{
            color: red;
        }
    }
</style>
